module.exports = __webpack_public_path__ + "static/marketing-plan-9e3cef927a022f741b0b33bf155fb33b.png";